import ServerSettings from "../../../gd/settings/server-settings/server-settings"
import {TaskViewLayout} from "../../../model2/task-type/@conts"

export enum TaskViewWidth {
    FIXED   = 0,
    AUTO    = 1
}

const fieldsConfig = {
    'layout': {
        type        : 'option',
        defaultValue: TaskViewLayout.DEFAULT,
        options     : [
            TaskViewLayout.DEFAULT,
            TaskViewLayout.DETAILS,
            TaskViewLayout.SIDEPANEL,
        ]
    },
    'width': {
        type        : 'option',
        defaultValue: TaskViewWidth.AUTO,
        options     : [
            TaskViewWidth.AUTO,
            TaskViewWidth.FIXED,
        ]
    },
}

export default class UserSettingsViewsTaskView extends ServerSettings {

    public layout           : TaskViewLayout
    public width            : TaskViewWidth

    constructor(config: any) {
        super(config, fieldsConfig)

        this.layout         = this.initValue('layout')
        this.width          = this.initValue('width')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'layout')
        this.valueToJson(result, 'width')

        return result
    }
}
